import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = ['Paiement sécurisé', 'Accès numérique immédiat', 'Ressources en français'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-99" data-mp="12mzfp1tns9jg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-100" data-mp="1zcql3w3hnh41">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-101" data-mp="1za4ebyof95mv">
          💈 Pour les formateurs en barbering et les académies
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-102" data-mp="1lc62p11hjnb2">
          Préparez vos cours de barbering en <Accent data-id="element-103" data-mp="9vpkx12gkul1">quelques minutes</Accent>, pas en plusieurs heures.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-104" data-mp="38hmlirxuonx3">
          Des ressources pédagogiques structurées pour enseigner avec plus de clarté, moins de
          préparation et davantage de confiance.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Barber Instructor Ready — Édition française : les six volumes, avec le Volume 1 au centre, sur tablette, ordinateur et téléphone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(20, 40, 59, 0.18))'
    }} data-id="element-105" data-mp="34dydy997xsbu" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-106" data-mp="2konzeyl7ldfb">
        📚 <strong className="font-semibold text-brand-charcoal" data-id="element-107" data-mp="2bpssfkacbzay">6 volumes pédagogiques + 5 bonus</strong>{' '}
        pour organiser vos cours, expliquer les techniques de coupe, proposer des exercices pratiques
        et évaluer les compétences de vos élèves.
      </p>
      <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-brand-charcoal sm:text-[16px]" data-id="element-108" data-mp="ch0vr9yxrsw0">
        Moins de temps passé à préparer. Plus de temps consacré à enseigner. ✂️
      </p>

      <CtaBlock label="Obtenir mes 6 volumes" className="mt-9" data-id="element-109" data-mp="108pxti1k7vq5" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-110" data-mp="107wvct9mvsdt">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-111" data-mp="w59wi8ejp774">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-112" data-mp="m96zfgyjvyr1" />
            {item}
          </li>)}
      </ul>
    </section>;
}